import InfoGraphicChart from './infoGraphicChart.module';
import InfoGraphicChartPie from './infoGraphicChartPie.module';
import InfoGraphicChartColumn from './infoGraphicChartColumn.module';

export default class InfoGraphicChartCreator {
  constructor( node ) {
    let jsonData = this.getChartDataFromAttribute( node );
    let type = ( jsonData.chart && jsonData.chart.type ) || 'column';
    this.initChart( node, type, jsonData );
  }
  initChart( node, type, data ) {
    switch ( type ) {
    case 'pie': {
      new InfoGraphicChartPie( node, data );
      break;
    }
    case 'column': {
      new InfoGraphicChartColumn( node, data );
      break;
    }
    default: {
      new InfoGraphicChart( node, data );
    }
    }
  }
  getChartDataFromAttribute( node ) {
    let highchartsConfig = node.getAttribute( 'data-chart' );
    return JSON.parse( highchartsConfig );
  }
}
